<div class="p-32 date-filters">
  <div class="flex flex-row justify-between">
    <div class="mat-subtitle-1 fw-700">
      {{'INSTANCE_DETAILS.SELECT_CUSTOM_DATE' | transloco }}
    </div>
    <mat-icon svgIcon="close" class="cursor-pointer w-32 h-32" (click)="cancelFilter()"></mat-icon>
  </div>

  <div class="flex flex-col">
    <div class="mat-subtitle-1 fw-700 fs-12 mb-0">{{'INSTANCE_DETAILS.FROM' | transloco }}</div>
    <mat-form-field class="example-full-width">
      <input matInput [matDatepicker]="picker" (dateChange)="startDateChange($event)" (click)="picker.open()" placeholder="MM/DD/YYYY" [value]="startDate">
      <mat-datepicker-toggle matIconSuffix [for]="picker">
        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker [startAt]="startDate" #picker></mat-datepicker>
    </mat-form-field>
  </div>
  
  <div  class="flex flex-col">
    <div class="mat-subtitle-1 fw-700 fs-12 mb-0">{{'INSTANCE_DETAILS.TO' | transloco }}</div>
    <mat-form-field class="example-full-width">
      <input matInput [matDatepicker]="picker1" (dateChange)="endDateChange($event)" (click)="picker1.open()" placeholder="MM/DD/YYYY" [value]="endDate">
      <mat-datepicker-toggle matIconSuffix [for]="picker1">
        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>
  </div>
  
  <div class="flex justify-between">
    <button class="reset-btn p-0" type="button" (click)="resetFilter()">{{'BUTTONS.RESET_FILTER' | transloco}}</button>
    <div class="flex gap-4">
      <button class="cancel-btn" type="button" (click)="cancelFilter()">{{'BUTTONS.CANCEL' | transloco}}</button>
      <button class="accent" type="button" [ngClass]="((initialStartDate !== startDate || initialEndDate !== endDate) && startDate && endDate) ? 'enabled' : 'disabled'" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
    </div>
  </div>
</div>